var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-footer',{staticClass:"pa-0 py-5 base-footer no-print",attrs:{"app":"","inset":"","fixed":""}},[_c('v-row',{staticClass:"max-content-width px-sm-10 px-5"},[_c('v-col',{staticClass:"px-0 px-sm-5",attrs:{"cols":"12"}},[_vm._t("default")],2)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }